import { render, staticRenderFns } from "./AltMap.vue?vue&type=template&id=e3835c40&"
import script from "./AltMap.vue?vue&type=script&lang=js&"
export * from "./AltMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports